
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.8 12.715v7.765H0c0-4.289 3.941-7.765 8.8-7.765zm6.598 7.277l-3.23 1.5.617-3.176-2.613-2.25 3.61-.464 1.616-2.887 1.618 2.887 3.613.464-2.613 2.25.617 3.176zm-6.597-8.25c-3.649 0-6.602-2.601-6.602-5.824 0-3.215 2.953-5.82 6.602-5.82 3.648 0 6.597 2.605 6.597 5.82 0 3.223-2.949 5.824-6.597 5.824zm0 0","fill":"#3e9f3c"}})])
          )
        }
      }
    